import React from "react";
import { ThemeProvider, ColorModeProvider, CSSReset } from "@chakra-ui/core";
import { customTheme } from "./theme";
import { Global, css } from "@emotion/core";
import AppContextProvider from "context/AppContext";
import HomePage from "page/Home";

import PageContextProvider from "context/PageContext";
import Navigation from "components/navigation/Navigation";
import Syncher from "Syncher";
import { HeroContextProvider } from "context/HeroContext";

function getData() {
  let dataSrc = document.getElementById("data")?.textContent;
  let data = dataSrc ? JSON.parse(dataSrc) : null;
  return data;
}

export default function App() {
  let data = getData();
  return (
    <ThemeProvider theme={customTheme}>
      <Global
        styles={css`
          html {
            scroll-behavior: smooth;
          }
          body {
            @media (max-width: 800px) {
            }
          }
        `}
      />
      <CSSReset />
      <ColorModeProvider value={"light"}>
        <PageContextProvider>
          <HeroContextProvider>
            <AppContextProvider data={data}>
              <HomePage />
              <Syncher />
            </AppContextProvider>
          </HeroContextProvider>
        </PageContextProvider>
      </ColorModeProvider>
    </ThemeProvider>
  );
}
